module.exports = __webpack_public_path__ + "img/o3.5c3a6854.svg";